import { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Lightbulb } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type FunFactCardProps = {
  title: string;
  content: string;
};

export function FunFactCard({ title, content }: FunFactCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Pressable accessibilityRole="button" onPress={() => setExpanded((value) => !value)}>
      <AppCard style={styles.card}>
        <View style={styles.header}>
          <Lightbulb size={18} color={tokens.colors.warning} />
          <AppText variant="body" weight="bold">
            {title}
          </AppText>
        </View>
        <AppText variant="caption" tone="muted" numberOfLines={expanded ? undefined : 2}>
          {content}
        </AppText>
      </AppCard>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.sm,
    backgroundColor: tokens.colors.warningSoft,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
});
